import React from 'react';
import { Calendar } from '@common/components/Calendar';
import moment, { isMoment } from 'moment-timezone';
import { Control, useController, UseControllerProps } from 'react-hook-form';
import { FORMAT } from '../Form/SelectDate/SelectDate';
import { PersonalizationFormValues } from '../types';

export function DatePicker({
  name,
  label,
  control,
}: {
  name: UseControllerProps<PersonalizationFormValues>['name'];
  label?: string;
  control: Control<PersonalizationFormValues>;
} & React.ComponentProps<'input'>) {
  const minDate = moment();
  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
  });

  const handleOnChange = (date) => onChange(moment(date).format(FORMAT));
  const initialValue =
    typeof value === 'string' ? moment(value) : isMoment(value) ? value : moment();

  return (
    <Calendar
      input={{ onChange: handleOnChange, value: initialValue }}
      label={label}
      dateFormat={FORMAT}
      minDate={minDate}
    />
  );
}
